






















import { Component, Vue, Config, BasePage, Model, Watch, Prop } from "@/common";
// import AMapLoader from "@amap/amap-jsapi-loader";

@Component({})
export default class ShowMap extends BasePage {
  mapList = [];
  markers = [];

  markClick(index) {
    this.markers[index]();
  }

  mounted() {
    this.mapList.splice(0);
    this.markers.splice(0);
    window["AMapLoader"]
      .load({
        //首次调用 load
        key: "10fb7fec97640aeef42f9ba3b5b39b13", //首次load key为必填
        version: "2.0",
        plugins: ["AMap.Scale", "AMap.ToolBar"],
        AMapUI: {
          // 是否加载 AMapUI，缺省不加载
          version: "1.1", // AMapUI 缺省 1.1
          plugins: ["overlay/SimpleMarker"], // 需要加载的 AMapUI ui插件
        },
      })
      .then((AMap) => {
        this.$http
          .get("Biz/Track/GetCurrentLngLat")
          .then((res) => {
            if (res.data.data.length > 0) {
              var map = new AMap.Map("container", {
                zoom: 10,
                center: [res.data.data[0].LONG, res.data.data[0].LAT],
              });
              map.addControl(new AMap.Scale());
              map.addControl(
                new AMap.ToolBar({
                  position: {
                    top: "60px",
                    right: "40px",
                  },
                })
              );

              var path = [];

              res.data.data.forEach((item, index) => {
                path.push([item.LONG, item.LAT]);
                this.mapList.push(item.Y_NO);

                var marker = new window["AMapUI"].SimpleMarker({
                  iconLabel: {
                    //普通文本
                    innerHTML: index + 1,
                    //设置样式
                    style: {
                      color: "#fff",
                      fontSize: "120%",
                      marginTop: "2px",
                    },
                  },
                  iconStyle: "blue",
                  position: [item.LONG, item.LAT],
                });

                var showMapFun = function () {
                  infoWindow(item.ADDRESS+"&nbsp;&nbsp;&nbsp;", [
                    "运单号:" + item.Y_NO,
                    "登记时间: " + item.TIMES.replace("T", " ").substr(0, 19),
                  ]).open(map, marker.getPosition());
                };

                marker.on("click",showMapFun);

                map.add(marker);
                this.markers.push(showMapFun);
              });

              function infoWindow(title, info) {
                var content = info;
                content.push(info);
                return new AMap.InfoWindow({
                  isCustom: true, //使用自定义窗体
                  content: createInfoWindow(title, content.join("<br/>")),
                  offset: new AMap.Pixel(16, -45),
                });
              }

              //构建自定义信息窗体
              function createInfoWindow(title, content) {
                var info = document.createElement("div");
                info.className = "custom-info input-card content-window-card";

                // 定义顶部标题
                var top = document.createElement("div");
                var titleD = document.createElement("div");
                var closeX = document.createElement("img");
                top.className = "info-top";
                titleD.innerHTML = title;
                closeX.src = "https://webapi.amap.com/images/close2.gif";
                closeX.onclick = closeInfoWindow;

                top.appendChild(titleD);
                top.appendChild(closeX);
                info.appendChild(top);

                // 定义中部内容
                var middle = document.createElement("div");
                middle.className = "info-middle";
                middle.style.backgroundColor = "white";
                middle.innerHTML = content;
                info.appendChild(middle);

                // 定义底部内容
                var bottom = document.createElement("div");
                bottom.className = "info-bottom";
                bottom.style.position = "relative";
                bottom.style.top = "0px";
                bottom.style.margin = "0 auto";
                var sharp = document.createElement("img");
                sharp.src = "https://webapi.amap.com/images/sharp.png";
                bottom.appendChild(sharp);
                info.appendChild(bottom);
                return info;
              }

              //关闭信息窗体
              function closeInfoWindow() {
                map.clearInfoWindow();
              }
            }
          })
          .catch((res) => {
            new AMap.Map("container", { center: [116.39, 39.9] });
          });
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
